<template>
  <ul class="accordion" v-if="data.length > 0">
    <li class="accordion__list" v-for="(data, index) in data" :key="index">
        <a
          href="#"
          class="accordion__anchor"
          :class="{ 'is-opened' : index == 0 }"
          @click.prevent="toggle($event)"
        >
          <div class="accordion__text">{{ data.title }}</div>
        </a>
        <div class="accordion__contents">
          <div class="accordion__text accordion__text--grey">
              {{ data.contents }}
          </div>
        </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      defaults: []
    }
  },
  methods: {
    toggle(e) {
      [...e.currentTarget.classList]
        .indexOf('is-opened') === 1
        ? this.close(e.currentTarget)
        : this.open(e.currentTarget);
    },
    open($target) {
      [...document.querySelectorAll('.accordion__anchor')]
        .forEach((element) => {
          this.close(element);
        });
      $target.classList.add('is-opened');
    },
    close($target) {
      $target.classList.remove('is-opened');
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/mixin.scss';

.accordion {
  &__list {
    &:first-child {
      border-top: 1px solid #888;
    }
    &:not(:first-child) {
      border-top: 1px solid #fff;
    }
  }
  &__anchor {
    width: 100%;
    height: 70px;
    position: relative;
    @include flexbox();
    @include align-items(center);
    box-sizing: border-box;
    text-decoration: none;
    color: #222;
    &::before {
      margin-right: 15px;
      width: 17px;
      height: 23px;
      background: url('../assets/images/icon-qna.png') no-repeat;
      display: block;
      content: '';
    }
    &::after {
      position: absolute;
      top: 50%;
      right: 30px;
      @include css-prefix(transform, translateY(-50%));
      width: 25px;
      height: 25px;
      background: url('../assets/images/icon-plus-minus.png') no-repeat 0 0;
      content: '';
    }
    &.is-opened::after {
      background-position: -25px 0;
    }
    &.is-opened ~ .accordion__contents {
      display: flex;
      max-height: 500px;
    }
  }
  &__contents {
    width: 100%;
    max-height: 0;
    @include flexbox();
    @include align-items(flex-start);
    overflow: hidden;
    position: relative;
    background-color: #fff;
    @include css-prefix(transition, all .3s);
    &::before {
      position: absolute;
      top: 28px;
      left: 30px;
      width: 17px;
      height: 23px;
      background: url('../assets/images/icon-qna.png') no-repeat -22px 0;
      content: '';
    }
    .accordion__text {
      padding: 30px 85px 24px 64px;
    }
  }
  &__text {
    padding-left: 32px;
    width: 100%;
    font-size: 22px;
    font-weight: 500;
    &--grey {
      margin-top: -10px;
      line-height: 36px;
      font-size: 19px;
      color: #666;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Accordion.vue